import { useRouter } from "next/router";
import { FeaturePermission } from "@/__generated__/featurePermissions";
import { useUser } from "@/auth/useUser";
import { useSuppliesSavingsQuery } from "@/graphql/queries/suppliesSavings.graphql.types";
import useFeatureFlags from "@/hooks/common/useFeatureFlags";

export const useSuppliesSavings = (): {
  monthlySavings: number;
  totalSavings: number;
  onReportClick?: () => void;
} => {
  const router = useRouter();
  const { userMedspa, hasFeaturePermission } = useUser();
  const { globalSuppliesSavingsV1Enabled } = useFeatureFlags();

  const canViewSuppliesSavings = hasFeaturePermission(
    FeaturePermission.VIEW_SUPPLIES_SAVINGS
  );

  const canViewSuppliesSavingsReport = hasFeaturePermission(
    FeaturePermission.VIEW_SUPPLIES_SAVINGS_REPORTS
  );

  const medspaId = userMedspa?.medspa?.id;

  const { data } = useSuppliesSavingsQuery({
    variables: { medspaId },
    skip:
      !medspaId || !canViewSuppliesSavings || !globalSuppliesSavingsV1Enabled,
  });

  const categoryId = data?.suppliesSavings?.categoryId;

  const providerOwnerOptions = {
    onReportClick: () => {
      if (categoryId) {
        router.push("/" + medspaId + "/reports/" + categoryId);
      }
    },
  };

  return {
    monthlySavings: data?.suppliesSavings?.pastMonth ?? 0,
    totalSavings: data?.suppliesSavings?.allTime ?? 0,
    ...(canViewSuppliesSavingsReport && providerOwnerOptions),
  };
};
